var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m12 1.5c-1.3924 0-2.72775.55312-3.71231 1.53769-.98457.98457-1.53769 2.31992-1.53769 3.71231v3c-.79565 0-1.55871.3161-2.12132.8787s-.87868 1.3257-.87868 2.1213v6.75c0 .7956.31607 1.5587.87868 2.1213s1.32567.8787 2.12132.8787h10.5c.7956 0 1.5587-.3161 2.1213-.8787s.8787-1.3257.8787-2.1213v-6.75c0-.7956-.3161-1.5587-.8787-2.1213s-1.3257-.8787-2.1213-.8787v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3c0-.99456-.3951-1.94839-1.0983-2.65165-.7033-.70326-1.6571-1.09835-2.6517-1.09835s-1.9484.39509-2.65165 1.09835c-.70326.70326-1.09835 1.65709-1.09835 2.65165v3z","fill":"currentColor","fillRule":"evenodd"}));
}

Lock.defaultProps = {"fill":"none","height":"24","tabIndex":"-1","viewBox":"0 0 24 24","width":"24"};

module.exports = Lock;

Lock.default = Lock;
